const ADD_NOTIFICATION = 'NOTIFICATIONS/ADD_NOTIFICATION';
const RESOLVE_NOTIFICATION = 'NOTIFICATIONS/RESOLVE_NOTIFICATION';

export { ADD_NOTIFICATION, RESOLVE_NOTIFICATION };
